import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  children,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-lg' : 'px-8 py-4 text-base';
  return <a href="https://tryreliq.com/products/korean-silk-lifting-peptide-ampoule" target="_blank" rel="noopener noreferrer" className={`inline-block bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 text-center ${sizeClasses} ${className}`} data-id="element-377">
      {children}
    </a>;
}